/**
 * Avanzamento della fatturazione di una commessa, da 0 a 100%.
 *
 * Tre segmenti sullo stesso metro: quello che è già stato fatturato, quello
 * che è deciso e in coda, e quello che manca. Un numero accanto all'altro
 * costringeva a fare la divisione a mente; qui si vede.
 */
const fmt = (n) => new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(Number(n) || 0);
const pct = (parte, tutto) => (tutto > 0 ? Math.max(0, Math.min(100, (parte / tutto) * 100)) : 0);

export default function BarraFatturazione({ budget, fatturato, inCoda = 0, alta = false,
                                            etichette = true, mostraMancante = true }) {
  const tot = Number(budget) || 0;
  const emesso = Number(fatturato) || 0;
  const coda = Number(inCoda) || 0;
  const pEmesso = pct(emesso, tot);
  const pCoda = Math.min(pct(coda, tot), 100 - pEmesso);
  const manca = Math.max(0, tot - emesso - coda);
  const altezza = alta ? 'h-4' : 'h-2.5';

  return (
    <div className="w-full">
      <div className={`relative w-full bg-gray-200 rounded-full ${altezza} overflow-hidden flex`}
           title={`Fatturato ${fmt(emesso)} · in coda ${fmt(coda)} · manca ${fmt(manca)} su ${fmt(tot)}`}>
        <div className={`${altezza} bg-green-500 transition-all`} style={{ width: `${pEmesso}%` }} />
        <div className={`${altezza} bg-amber-400 transition-all`} style={{ width: `${pCoda}%` }} />
      </div>
      {etichette && (
        <div className="flex justify-between gap-2 text-[11px] text-gray-500 mt-0.5 whitespace-nowrap">
          <span>{Math.round(pEmesso)}% fatturato{coda > 0 ? ` · ${Math.round(pCoda)}% in coda` : ''}</span>
          {mostraMancante && (
            <span className={manca > 0.005 ? 'text-amber-700 font-medium' : 'text-green-700 font-medium'}>
              {manca > 0.005 ? `manca ${fmt(manca)}` : 'tutto deciso'}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
